import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';  
  @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {   	
        $event.returnValue = false;       
    }
	@HostListener('contextmenu', ['$event'])
	onRightClick(event) {
	  event.preventDefault();
	}
}



// WEBPACK FOOTER //
// D:/Laxmi/angular/forms/XpressForms/src/app/app.component.ts